import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=2b06a0cc&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "./Container.vue?vue&type=style&index=0&id=2b06a0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06a0cc",
  null
  
)

export default component.exports